import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { iframeUrl } from 'src/app/core/constant/iframeUrls';


@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss']
})
export class UserSearchComponent implements OnInit {
  iframeUrlUserSearch: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) { }

  ngOnInit(): void {
    let iframeUrlSearchUserRaw = iframeUrl.userSearch.url;
    this.iframeUrlUserSearch = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrlSearchUserRaw);
  }

  BackToDashboard() {
    this.router.navigate(['dashboard']);
  }
}
